import { useState, useEffect } from "react";
import { Box, Dialog, DialogContent } from "@mui/material";
import Input from "../Inputs/Input";
import CheckboxField from "../Checkbox/CheckboxField";
import { TextAreaComponent } from "../TextArea/TextAreaComponent";

import "./TabDialogConfiguration.scss";

export function TabDialogConfiguration({
  isOpen,
  onClose,
  onUpdateTab,
  selectedTab,
}) {
  const [formData, setFormData] = useState({
    tabName: selectedTab?.label || "",
    showTitleInUppercase: selectedTab?.showTitleInUppercase || false,
    tabDescription: selectedTab?.tabDescription || "",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (selectedTab) {
      setFormData({
        tabName: selectedTab?.label || "",
        showTitleInUppercase: selectedTab?.showTitleInUppercase || false,
        tabDescription: selectedTab?.tabDescription || "",
      });
    }
  }, [selectedTab]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (checked) => {
    setFormData((prev) => ({
      ...prev,
      showTitleInUppercase: checked,
    }));
  };

  const handleSave = async () => {
    if (!selectedTab || !onUpdateTab) return;

    try {
      setIsLoading(true);
      await onUpdateTab(selectedTab.tabId, formData);
      onClose();
    } catch (error) {
      console.error("Error updating tab:", error);
      // Aquí podrías mostrar un mensaje de error al usuario
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "23px",
          border: "1px solid #707070",
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            minWidth: {
              xs: "calc(100vw - 4rem)",
              sm: "calc(100vw - 8rem)",
              md: "calc(100vw - 20rem)",
              lg: "calc(100vw - 30rem)",
              xl: "min(calc(100vw - 50rem), 80rem)",
            },
            "@media (min-width: 2000px)": {
              minWidth: "min(calc(100vw - 60rem), 80rem)",
            },
            minHeight: "calc(100vh - 23rem)",
          }}
        >
          <section className="tab-dialog-header">
            <span className="tab-dialog-header-title">
              Edit Tab - {selectedTab?.label || "Unknown Tab"}
            </span>
            <button
              className="filled tab-dialog-header-btn-save"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
            <button
              className="outlined tab-dialog-header-btn-close icon-cross"
              onClick={onClose}
            ></button>
          </section>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              pt: 2,
              paddingTop: "1.2rem",
            }}
          >
            {/* Tab Name Input */}
            <Box>
              <label
                style={{
                  display: "block",
                  color: "#000000",
                  fontSize: "14px",
                  textAlign: "left",
                  marginBottom: "8px",
                  fontWeight: "normal",
                }}
              >
                Tab Name
              </label>
              <Input
                name="tabName"
                value={formData.tabName}
                onChange={handleInputChange}
                placeholder="Enter tab name"
                required
              />
            </Box>

            {/* Show Title in Upper Case Checkbox */}
            <Box>
              <CheckboxField
                checked={formData.showTitleInUppercase}
                onChange={handleCheckboxChange}
              >
                Show title in upper case
              </CheckboxField>
            </Box>

            {/* Description TextArea */}
            <Box>
              <label
                style={{
                  display: "block",
                  color: "#000000",
                  fontSize: "14px",
                  textAlign: "left",
                  marginBottom: "8px",
                  fontWeight: "normal",
                }}
              >
                Description (optional)
              </label>
              <TextAreaComponent
                name="tabDescription"
                value={formData.tabDescription}
                onChange={handleInputChange}
                placeHolder="Enter tab description"
                styles={{
                  minHeight: "120px",
                  width: "100%",
                }}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
